
// @ts-ignore
import {translate} from '@elements/translations';
import {defineComponent, reactive, watch, onMounted, ref} from 'vue';
import {useTicketStore} from '~vue/stores/TicketStore.ts';
import {useCalendarStore} from '~vue/stores/CalendarStore.ts';
import {storeToRefs} from 'pinia'
import Error from "~vue/components/error/Error.vue";

export default defineComponent({
    name: 'SuccessView',
    components: {Error},
    emits: ['isLoading', 'closeModal'],
    props: {
        successData: {
            type: Object,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
    },
    setup(props, {emit}) {
        const ticketStore = useTicketStore();
        const {
            ticketConfigurations,
            selectedTicketName,
        } = storeToRefs(ticketStore);
        const {changeShowModal, resetAll, total} = ticketStore;
        const calendarStore = useCalendarStore();
        const {resetShownCalendarMonth} = calendarStore;
        const isMobile = matchMedia('(max-width: 767px)').matches;

        const _config = window._config || {};
        const baseUrl = _config.successUrls;

        if (!baseUrl) {
            console.error('warning', 'MISSING CONFIG', 'Missing config "_config.successUrls". Value of "_config.successUrls" was not set in _config', true);
        }

        const continueUrl = baseUrl.continueShopping;
        const cartUrl = baseUrl.cart;
        const checkoutUrl = baseUrl.checkout;

        const onCloseModal = () => {
            changeShowModal(false);
            resetAll();
            resetShownCalendarMonth();
            emit('closeModal');
        };

        return {
            emit,
            translate,
            onCloseModal,
            continueUrl,
            cartUrl,
            total,
            isMobile,
            ticketConfigurations,
            changeShowModal,
            selectedTicketName,
            checkoutUrl,
        };
    }
});
